import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import ReactDOM from 'react-dom';
import { isHubSpotNativeApp } from '../../../utils/utils'; // @ts-expect-error no types

import StolenFaceNav from '../../../components/StolenFaceNav';
import UIFlex from 'UIComponents/layout/UIFlex'; // @ts-expect-error no types

import HubspotSoftwareNavHider from '../../../containers/HubspotSoftwareNavHider';
import styled, { theme, useMediaQuery } from '../../../utils/Styling';
import NavbarMobileTabs from './NavbarMobileTabs';
import NavbarTabs from './NavbarTabs';
import AcademyToSoftware from '../../../containers/AcademyToSoftware/AcademyToSoftware';
import { DevtoolsButton } from '../../devtools';
const StickyDiv = styled.div.withConfig({
  displayName: "Navbar__StickyDiv",
  componentId: "sc-1q8xrw5-0"
})(["display:flex;background:", ";"], theme.colors.PANTERA);
const NavSeparator = styled.div.withConfig({
  displayName: "Navbar__NavSeparator",
  componentId: "sc-1q8xrw5-1"
})(["height:28px;width:1px;background:", ";margin:4px 6px 0 18px;"], theme.colors.SLINKY);
export const Navbar = () => {
  const {
    isMobileNavbar
  } = useMediaQuery();
  return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/_jsxs(StickyDiv, {
    children: [/*#__PURE__*/_jsx(HubspotSoftwareNavHider, {}), isMobileNavbar ? /*#__PURE__*/_jsx(NavbarMobileTabs, {}) : /*#__PURE__*/_jsx(NavbarTabs, {}), !isHubSpotNativeApp && /*#__PURE__*/_jsx("div", {
      className: "vr-hidden",
      style: {
        width: 'fit-content'
      },
      children: /*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        style: {
          height: '48px',
          paddingLeft: '20px',
          maxWidth: 'fit-content',
          marginLeft: 'auto'
        },
        children: [/*#__PURE__*/_jsx(AcademyToSoftware, {}), /*#__PURE__*/_jsxs(UIFlex, {
          align: "center",
          children: [/*#__PURE__*/_jsx(NavSeparator, {}), /*#__PURE__*/_jsx(DevtoolsButton, {}), /*#__PURE__*/_jsx(StolenFaceNav, {})]
        })]
      })
    })]
  }), document.body.querySelector('#academy-nav'));
};